var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99998 3.71784e-05C2.7441 3.71784e-05 2.48794 0.0975058 2.29294 0.293006L0.292945 2.29301C-0.0980552 2.68401 -0.0980552 3.31707 0.292945 3.70707L7.58591 11L0.292945 18.293C-0.0980552 18.684 -0.0980552 19.3171 0.292945 19.7071L2.29294 21.7071C2.68394 22.0981 3.31701 22.0981 3.70701 21.7071L11 14.4141L18.2929 21.7071C18.6829 22.0981 19.317 22.0981 19.707 21.7071L21.707 19.7071C22.098 19.3161 22.098 18.683 21.707 18.293L14.414 11L21.707 3.70707C22.098 3.31707 22.098 2.68301 21.707 2.29301L19.707 0.293006C19.316 -0.0979941 18.6829 -0.0979941 18.2929 0.293006L11 7.58598L3.70701 0.293006C3.51151 0.0975058 3.25585 3.71784e-05 2.99998 3.71784e-05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0f56727d05827d9c2427bd3d38883a70.svg";
export { ForwardRef as ReactComponent };